import Logo from "./Logo";
import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import theme from "@styles/theme";
import { AppBar, Divider, Grid, Toolbar } from "@mzc-pdc/ui";
import ProfileMenu from "../../features/profile-menu/profile-menu";
import { alpha } from "@mui/material";
import StartMenu from "@features/start-menu/start-menu";
import { siteMode } from "@cores/siteMode";

const HeaderForNoting = () => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const isLxhausys = window.location.hostname.indexOf("lxhausys.") > -1;
    const isLibrary = siteMode.get() === "CMS";

    const user = useSelector(({ user }) => user);

    const isPopup = useMemo(() => {
        return Boolean(searchParams.get("popup"));
    }, [search]);

    return (
        <>
            {user.stages?.data && !isPopup && (
                <AppBar
                    position="fixed"
                    sx={{
                        backgroundColor: theme.palette.background.default,
                        color: theme.palette.text.primary,
                        fill: theme.palette.text.primary,
                        boxShadow: `none`,
                        borderBottom: `1px solid ${alpha(theme.palette.greySecondary[300], 0.32)}`,
                        zIndex: (props) => props.zIndex.drawer + 1,
                    }}
                >
                    <Toolbar sx={{ padding: `0 !important` }}>
                        <Grid container justifyContent={`space-between`} alignItems={`center`}>
                            <Grid item>
                                <Grid container alignItems={"center"} height={theme.mixins.toolbar.minHeight}>
                                    {!isLibrary && (
                                        <>
                                            <Grid item px={1.5}>
                                                <StartMenu />
                                            </Grid>
                                            <Divider
                                                flexItem
                                                orientation={"vertical"}
                                                sx={{
                                                    marginLeft: `-1px`,
                                                    background: `none`,
                                                    borderColor: alpha(theme.palette.greySecondary[300], 0.32),
                                                }}
                                            />
                                        </>
                                    )}
                                    <Grid item pl={2.5}>
                                        <Logo
                                            to={
                                                location.pathname.indexOf(`/library`) > -1
                                                    ? `/library/spaces`
                                                    : "/spaces"
                                            }
                                            imgSrc={
                                                isLxhausys
                                                    ? "https://mzc-cm-lxhausys-common-resources.s3.amazonaws.com/uploads/logos/1717998451lx8jx5h7_cpm_custom_logo.png"
                                                    : undefined
                                            }
                                            fill={theme.palette.text.primary}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item pr={1}>
                                <ProfileMenu />
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            )}
        </>
    );
};

export default HeaderForNoting;
